// extracted by css-extract-rspack-plugin
export default {"dataList":"afrAVprlIWQqg_14","dataListWrapper":"I7ii1QcEWIQLXxR8","dataListContent":"cTcXHC2ljPE3TWTd"};